(() => {
  const HEADER_SELECTOR = '.scotland-header';
  const DRAWER_SELECTOR = `${HEADER_SELECTOR} header-drawer`;
  const FLYOUT_SELECTOR = `${HEADER_SELECTOR} .scotland-header__menu-flyout`;
  const CLOSE_DELAY = 180;

  function bindDrawerMenuLinks() {
    document.querySelectorAll(DRAWER_SELECTOR).forEach((drawer) => {
      if (drawer.dataset.scotlandDrawerBound === 'true') return;
      drawer.dataset.scotlandDrawerBound = 'true';

      drawer.querySelectorAll('.scotland-drawer__menu-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
    });
  }

  function closeFlyout(flyout) {
    flyout.classList.remove('is-open');
    flyout.querySelectorAll('.scotland-header__menu-link').forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
    });
  }

  function openFlyout(flyout) {
    document.querySelectorAll(FLYOUT_SELECTOR).forEach((other) => {
      if (other !== flyout) closeFlyout(other);
    });

    flyout.classList.add('is-open');
    flyout.querySelectorAll('.scotland-header__menu-link').forEach((link) => {
      link.setAttribute('aria-expanded', 'true');
    });
  }

  function bindMenuFlyouts() {
    document.querySelectorAll(FLYOUT_SELECTOR).forEach((flyout) => {
      if (flyout.dataset.scotlandFlyoutBound === 'true') return;
      flyout.dataset.scotlandFlyoutBound = 'true';

      let closeTimer = 0;

      const cancelClose = () => {
        window.clearTimeout(closeTimer);
      };

      const scheduleClose = () => {
        cancelClose();
        closeTimer = window.setTimeout(() => closeFlyout(flyout), CLOSE_DELAY);
      };

      flyout.addEventListener('mouseenter', () => {
        cancelClose();
        openFlyout(flyout);
      });

      flyout.addEventListener('mouseleave', scheduleClose);

      flyout.addEventListener('focusin', () => {
        cancelClose();
        openFlyout(flyout);
      });

      flyout.addEventListener('focusout', (event) => {
        if (!flyout.contains(event.relatedTarget)) scheduleClose();
      });
    });
  }

  function init() {
    bindDrawerMenuLinks();
    bindMenuFlyouts();
  }

  function revealInEditor() {
    requestAnimationFrame(function () {
      document.querySelector('.scotland-header-wrapper')?.classList.add('is-loaded');
    });
  }

  init();
  document.addEventListener('shopify:section:load', function () {
    init();
    revealInEditor();
  });
})();
